/**
 * HexagonLogo - Fantomize Brand Logo Component
 *
 * The iconic hexagon with 6 internal lines meeting at center.
 * Used across the app for consistent branding.
 */
import React from 'react';

const HexagonLogo = ({
  size = 32,
  strokeWidth = 2.5,
  className = '',
  animated = false,
  onClick = null
}) => {
  const gradientId = `hexGradient-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <svg
      className={`hexagon-logo ${className} ${animated ? 'hexagon-logo-animated' : ''}`}
      viewBox="0 0 100 100"
      width={size}
      height={size}
      fill="none"
      stroke={`url(#${gradientId})`}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      onClick={onClick}
      style={onClick ? { cursor: 'pointer' } : {}}
    >
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#8B3A62" />
          <stop offset="100%" stopColor="#6B5B8E" />
        </linearGradient>
      </defs>
      {/* Outer hexagon */}
      <polygon points="50,6 90,28 90,72 50,94 10,72 10,28" />
      {/* 3 internal lines connecting opposite vertices through center */}
      <line x1="50" y1="6" x2="50" y2="94" />
      <line x1="90" y1="28" x2="10" y2="72" />
      <line x1="90" y1="72" x2="10" y2="28" />
    </svg>
  );
};

export default HexagonLogo;


